<template>
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">Dashboard</h4>

          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><router-link :to="{name:'dashboards'}">Dashboards</router-link></li> -->
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <!-- <div class="col-md-4">
        <totalTransaksiPerTahun></totalTransaksiPerTahun>
      </div> -->
      <div class="col-md-4">
        <revenue></revenue>
      </div>
      <!-- <div class="col-md-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="media-body">
                <p class="text-muted font-weight-medium">Average Price</p>
                <h4 class="mb-0">Rp350.723.000</h4>
              </div>

              <div
                class="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon"
              >
                <span class="avatar-title rounded-circle bg-primary">
                  <i class="bx bx-purchase-tag-alt font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="row">
      <div class="col-md-12">
        <totaltransaksiservis></totaltransaksiservis>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <checkSchedule/>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <categoryChart></categoryChart>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <countServices></countServices>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <totalTransaksi></totalTransaksi>
      </div>
    </div>

  </div>
</template>

<script>
import totaltransaksiservis from "@/views/dashboards/widget/total_transaksi_servis";
import categoryChart from "@/views/dashboards/widget/kategori_servis";
import totalTransaksi from "@/views/dashboards/widget/total_transaksi";
// import totalTransaksiPerTahun from "@/views/dashboards/widget/total_transaksi_per_tahun";
import revenue from "@/views/dashboards/widget/revenue";
import checkSchedule from "@/views/dashboards/widget/checkSchedule";
import countServices from "@/views/dashboards/widget/count_services";

export default {
  components: {
    totaltransaksiservis,
    categoryChart,
    // totalTransaksiPerTahun,
    revenue,
    checkSchedule,
    countServices,
    totalTransaksi
  },
  data() {
    return {
      table_module: "dashboards",
    };
  },
};
</script>
